import { api } from '@/plugins/api';
import request from '@/utils/request';

// 查询字典数据列表
export function listData(query) {
  return request({
    url: '/system/dict/data/list',
    method: 'get',
    params: query
  });
}

// 查询字典数据详细
export function getData(dictCode) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'get'
  });
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  if (typeof dictType === 'string') {
    return request({
      url: '/system/dict/data/type/' + dictType,
      method: 'get'
    });
  } else {
    return api.system.dict.data.types.getByTypes.r(dictType);
  }

}



// 新增字典数据
export function addData(data) {
  return request({
    url: '/system/dict/data',
    method: 'post',
    data: data
  });
}

// 修改字典数据
export function updateData(data) {
  return request({
    url: '/system/dict/data',
    method: 'put',
    data: data
  });
}

// 删除字典数据
export function delData(dictCode) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'delete'
  });
}
